export const VIDEO_SLIDES_ARENA_SWIPER_ID = 'video-slides-arena-swiper';